// store/slices/employeeUploadSlice.js
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axios from "axios";
const API_URL = process.env.REACT_APP_API_BASE_URL;
export const uploadEmployeeFile = createAsyncThunk(
  "employeeUpload/upload",
  async ({ file, module, companyId }, { rejectWithValue }) => { // 1. Added companyId here
    try {
      const formData = new FormData();
      formData.append("file", file);
      
      // 2. ONLY add companyId if it exists (for your backend context)
      if (companyId) {
        formData.append("companyId", companyId);
      }

      const response = await axios.post(
        `${API_URL}/data-import/upload/${module}`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      return response.data;
    } catch (err) {
      const message =
        err.response?.data?.message || err.message || "Failed to upload file";
      return rejectWithValue(message);
    }
  }
);

const employeeUploadSlice = createSlice({
  name: "employeeUpload",
  initialState: {
    data: [],
    status: "idle", // idle | loading | succeeded | failed
    error: null,
  },
  reducers: {
    resetUpload(state) {
      state.data = [];
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(uploadEmployeeFile.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(uploadEmployeeFile.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload || [];
      })
      .addCase(uploadEmployeeFile.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload || "Upload failed";
      });
  },
});

export const { resetUpload } = employeeUploadSlice.actions;
export default employeeUploadSlice.reducer;
